// Handle admin "Login as user" BEFORE React renders.
// This must be imported first in index.js.
//
// Hard session swap: the admin is fully replaced by the target user.
// Behaves like a real logout-then-login — every cached scrap of admin
// state (Redux persist, AppContext snapshots, saved-accounts list,
// sessionStorage tokens) is wiped before we reload. The admin must
// sign back in with their own credentials to return; there is no
// banner or one-click switch-back.
//
// Flow:
// 1. First visit with ?impersonate_token — wipe storage, plant only
//    the new token + a "pending" flag, reload.
// 2. After reload — AuthWrapper sees the flag, calls /user with the
//    new token, dispatches login() with the target user's profile.

const params = new URLSearchParams(window.location.search);
const impersonateToken = params.get('impersonate_token');
const impersonateUser = params.get('impersonate_user');

if (impersonateToken) {
  // Stash the welcome message so the new session can surface a toast
  // *after* storage is wiped (sessionStorage survives reload but is
  // tab-scoped, which is what we want here).
  if (impersonateUser) {
    try { sessionStorage.setItem('impersonation_welcome_user', impersonateUser); } catch {}
  }

  // True wipe — every key, every store. After this point nothing of
  // the admin's session remains. Redux-persist stores under
  // `persist:root` (the previous code cleared `persist:auth`, which
  // didn't exist, so admin state survived the reload — that was the
  // root cause of "Login as user still shows admin").
  try { localStorage.clear(); } catch {}
  try {
    // Preserve the welcome marker we just set.
    const welcome = sessionStorage.getItem('impersonation_welcome_user');
    sessionStorage.clear();
    if (welcome) sessionStorage.setItem('impersonation_welcome_user', welcome);
  } catch {}

  // Plant only what the next boot needs.
  localStorage.setItem('auth_token', impersonateToken);
  localStorage.setItem('impersonation_pending', 'true');

  // Land on /home and hard-reload so React, AppContext, and the
  // service-worker-cached chunks all re-initialise from scratch.
  window.history.replaceState({}, '', '/home');
  window.location.reload();
}
